<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'

import useLiveChat from '@/hooks/useLiveChat'

const { initializeLiveChat, isLiveChatLoaded } = useLiveChat()

let timeoutId: ReturnType<typeof setTimeout> | null = null
let hasLoaded = false

const loadLiveChat = () => {
  if (hasLoaded || isLiveChatLoaded.value) return
  hasLoaded = true
  initializeLiveChat()
}

// Load when user scrolls (any scroll shows engagement)
const handleScroll = () => {
  loadLiveChat()
}

// Load on user interaction (click/touch)
const handleUserInteraction = () => {
  loadLiveChat()
}

onMounted(() => {
  // Load after 30 seconds regardless (fallback)
  timeoutId = setTimeout(() => {
    loadLiveChat()
  }, 30000)

  // Load on scroll (engagement)
  window.addEventListener('scroll', handleScroll, { passive: true })

  // Load on first user interaction
  document.addEventListener('click', handleUserInteraction, { once: true, capture: true })
  document.addEventListener('touchstart', handleUserInteraction, { once: true, passive: true })
})

onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <div>
    <div v-if="isLiveChatLoaded" id="livechat_container"></div>
  </div>
</template>
